enum EmailFolder {
  SENT = "sent",
  INBOX = "inbox",
}

export default EmailFolder;
